// This file is automatically generated. Do not edit manually.

import { InvoiceLineUpdateService_UpdateRequest } from "src/api/generated/erp/sales/invoicing/service/invoiceLineUpdateService";
import { ObjectAccountingDimensionValue } from "src/api/generated/erp/common/accounting/objectAccountingDimensionValue";
import { InvoiceLine } from "src/api/generated/erp/db/types/tables/invoiceLine";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace InvoiceLineEditApi {
	export async function getFormInitData(args: { invoiceLineId: number }): Promise<InvoiceLineEditApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/invoiceLineEdit/getFormInitData",
			method: "POST",
			data: {
				invoiceLineId: args.invoiceLineId,
			},
		});
		return response as InvoiceLineEditApi_FormInitData;
	}

	export async function update(args: {
		request: InvoiceLineUpdateService_UpdateRequest;
		accountingCodeIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/invoiceLineEdit/update/v2",
			method: "POST",
			data: {
				request: args.request,
				accountingCodeIds: args.accountingCodeIds,
			},
		});
		return response as void;
	}
}

export interface InvoiceLineEditApi_FormInitData {
	accountingDimensions: Array<ObjectAccountingDimensionValue>;
	invoiceLine: InvoiceLine;
}
